import { FunctionComponent } from 'react'
import styles from './eventsHandler.module.scss'
import DaycareSelector from '@/components/DaycareSelector/daycareSelector'
import EventsList from './eventsList'
import { useAuth } from '@/modules/context/AuthContext'
import { Location, Navigate, useLocation } from 'react-router-dom'
import moment from 'moment/moment'

const EventsHandler: FunctionComponent = () => {
    const { user } = useAuth()

    const urlEvents: Location = useLocation()
    const paramEvents: URLSearchParams = new URLSearchParams(urlEvents.search)

    const fromDate: string = paramEvents.get('fromDate') || moment().format('DD-MM-YYYY')
    const toDate: string = paramEvents.get('toDate') || moment().format('DD-MM-YYYY')

    return (
        <div className={styles.PagePosition}>
            {user?.role &&
            user.currentDaycare &&
            (user?.currentDaycareRights.canReadEvents || user?.currentDaycareRights.canReadClosingDays) ? (
                <>
                    <div className={styles.HeaderRow}>
                        <div className={styles.MultipleSections}>
                            <DaycareSelector />
                        </div>
                    </div>
                    <div className={styles.EventsPlacement}>
                        <EventsList
                            role={user.role}
                            daycare={user.currentDaycare}
                            fromDate={fromDate}
                            toDate={toDate}
                        />
                    </div>
                </>
            ) : (
                <Navigate to='/' replace />
            )}
        </div>
    )
}

export default EventsHandler
